export default __webpack_public_path__ + "static/media/460.4c4ed7e2.png";